exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.announcement-highlight{position:relative;width:100%;height:100%;font-family:Oswald,sans-serif;font-size:24px;font-weight:300;font-style:normal;font-stretch:normal;top:10x;letter-spacing:normal;color:#2c2c2c;text-align:center;background-color:transparent;overflow-x:hidden;overflow-y:auto}.announcement-highlight .divider-line{position:absolute;width:100%;height:2px;left:0;top:38px;border-bottom:2px solid #d8d8d8}.mobile-wrapper .tab-array{height:38px;margin:0}.mobile-wrapper .tab-array .tab{width:33%}.mobile-wrapper .tab-array .tab.selected{height:40px}.mobile-wrapper .tab-array .tab .tab-label{margin-top:3px;font-size:22px}.mobile-wrapper .main-content{width:100%;height:calc(100% - 142px);margin-top:12px}.mobile-wrapper .main-content .offline-view{display:flex;flex-direction:column;justify-content:center;margin-top:19%}.mobile-wrapper .main-content .offline-view__text{font-family:Open Sans,sans-serif;font-size:24px;font-weight:600;text-align:center;color:#9b9b9b}.mobile-wrapper .main-content .offline-view__cloud-img{height:110px;margin-top:16px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/ProjectDetailsWrapper/ProjectDetailsWrapper.scss
// module id = 1870
// module chunks = 0